import script from "./LegoSetKlodser.vue?vue&type=script&setup=true&lang=ts"
export * from "./LegoSetKlodser.vue?vue&type=script&setup=true&lang=ts"

export default script